import { cn } from "@do/ui/lib/utils";
import { useMemo } from "react";
import { useChat } from "../../providers/chat-provider";
import { MarkdownRenderer } from "../markdown-renderer";

export const FooterLegal = () => {
  const { selectedLocale, defaultLocale, chatbotParams } = useChat();

  const disclaimerText = useMemo(() => {
    return (
      selectedLocale?.disclaimerText ||
      defaultLocale?.disclaimerText ||
      chatbotParams.disclaimerText
    );
  }, [selectedLocale, defaultLocale, chatbotParams.disclaimerText]);

  return (
    <MarkdownRenderer
      id="footer-legal-content-markdown"
      className={cn(
        "mb-[calc(var(--footer-padding-bottom)-4px)]",
        "[&.markdown-renderer]:text-(--footer-legal-content-color)/(--footer-legal-content-color-opacity)! [&.markdown-renderer]:text-(length:--footer-legal-content-font-size)!",
        "[&.markdown-renderer]:font-(--footer-legal-content-font-weight)! [&.markdown-renderer]:font-(family-name:--footer-legal-content-font-family)!",
        "[&.markdown-renderer]:leading-(--footer-legal-content-line-height)!"
      )}
      text={disclaimerText ?? ""}
    />
  );
};
